export const IDENTITY_TYPE = [
    { value: 303, label: "Identity card" },
    { value: 304, label: "Passport" },
    { value: 305, label: "Driving license" }
]
